import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.748 2a1 1 0 0 0-.867.5 1 1 0 1 1-1.731-1 3 3 0 1 1 3.598 4.33V6a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1 1 1 0 0 0 0-2ZM2.748 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render };